import { render } from "./AposDocsManagerToolbar.vue?vue&type=template&id=f8f73598&scoped=true"
import script from "./AposDocsManagerToolbar.vue?vue&type=script&lang=js"
export * from "./AposDocsManagerToolbar.vue?vue&type=script&lang=js"

import "./AposDocsManagerToolbar.vue?vue&type=style&index=0&id=f8f73598&lang=scss&scoped=true"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8f73598"],['__file',"modal/ui/apos/components/AposDocsManagerToolbar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f8f73598"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f8f73598', __exports__)) {
    api.reload('f8f73598', __exports__)
  }
  
  module.hot.accept("./AposDocsManagerToolbar.vue?vue&type=template&id=f8f73598&scoped=true", () => {
    api.rerender('f8f73598', render)
  })

}


export default __exports__